// components/BlogCard.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

const BlogCard = ({ blog }) => {
    const navigate = useNavigate();

    const formatDate = (dateString) => {
        const dateObj = new Date(dateString);
        const day = dateObj.getDate().toString().padStart(2, "0");
        const month = dateObj.toLocaleString("default", { month: "long" }).toUpperCase();
        return { day, month };
    };

    const { day, month } = formatDate(blog?.date || "2024-06-22");

    const stripHtml = (html) => {
        const tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    };

    const handleClick = () => {
        navigate(`/blog-details/${blog.slug}`);
    };

    return (
            <div className="shadow rounded-3 overflow-hidden h-100 d-flex flex-column bg-white">
                <div className="position-relative">
                    <img
                        loading="lazy"
                        src={`${process.env.REACT_APP_S3_URL}/uploads/blog/${blog?.image}`}
                        alt={blog?.title || "Blog thumbnail"}
                        title={blog?.title || "Blog image"}
                        className="img-fluid w-100"
                        style={{ height: "250px", objectFit: "cover" }}
                    />


                    <div
                        className="position-absolute text-white text-center"
                        style={{
                            top: 0,
                            left: 0,
                            backgroundColor: "rgb(54 52 52)",
                            padding: "8px 12px",
                            fontSize: "14px",
                            lineHeight: "1.2",
                        }}
                    >
                        <strong style={{ fontSize: "18px" }}>{day}</strong>
                        <br />
                        <span style={{ fontSize: "12px" }}>{month}</span>
                    </div>
                </div>

                <div className="p-3 d-flex flex-column flex-grow-1">
                    <h5 className="fw-bold mb-2" style={{ color: "#a8282f" }}>
                        {blog?.title || ""}
                    </h5>
                    <p className="text-muted small mb-3">
                        {stripHtml(blog?.description).slice(0, 200)}...
                    </p>

                    <button
                        onClick={handleClick}
                        className="btn w-100 mt-auto text-white fw-bold"
                        style={{ backgroundColor: "rgb(54 52 52)" }}
                    >
                        READ MORE
                    </button>
                </div>
            </div>
    );
};

export default BlogCard;
